import { ReactNode } from 'react';
import { Edit3, Power } from 'lucide-react';

interface Props {
  onEdit: () => void;
  /** Si se omite, no se muestra el botón de estado. */
  onToggle?: () => void;
  active?: boolean;
  toggleLabel?: { on: string; off: string };
  /** Botón adicional a la izquierda (p. ej. "Identificadores"). */
  extra?: ReactNode;
}

/** Acciones estándar de una fila de tabla del módulo de restaurante. */
const RestaurantTableActions = ({
  onEdit,
  onToggle,
  active = true,
  toggleLabel = { on: 'Desactivar', off: 'Activar' },
  extra,
}: Props) => (
  <div className="flex justify-end gap-2">
    {extra}

    <button
      type="button"
      onClick={onEdit}
      className="inline-flex items-center justify-center gap-2 rounded-xl border border-stroke px-3 py-2 text-sm font-medium transition hover:border-primary hover:bg-primary/5 hover:text-primary dark:border-strokedark"
    >
      <Edit3 className="h-4 w-4" /> Editar
    </button>

    {onToggle && (
      <button
        type="button"
        title={active ? toggleLabel.on : toggleLabel.off}
        onClick={onToggle}
        className={`inline-flex items-center gap-2 rounded-xl border px-3 py-2 text-sm font-medium transition ${
          active
            ? 'border-stroke text-danger hover:border-danger hover:bg-danger/5 dark:border-strokedark'
            : 'border-primary/30 bg-primary/5 text-primary hover:bg-primary hover:text-white'
        }`}
      >
        <Power className="h-4 w-4" />
        {active ? toggleLabel.on : toggleLabel.off}
      </button>
    )}
  </div>
);

export default RestaurantTableActions;
